import type { ContainerData, ElementData, ElementsData } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'

export const getPathToElementData = (compId: string, elementData: ElementsData): ElementsData => {
	const pathToElementData: ElementsData = {}

	Object.entries(elementData).forEach(([path, element]: [string, ElementData]) => {
		const fixedPath = path.replace(/^root/, compId)
		pathToElementData[fixedPath] = { selector: `.${compId}${element.selector}` } // we add the compId to the selector to make it unique

		_.forEach(element.containersData || {}, (container: ContainerData, propertyName: string) => {
			const { containerType, selector } = container

			if (!pathToElementData[fixedPath].containersData) {
				pathToElementData[fixedPath].containersData = {}
			}

			pathToElementData[fixedPath].containersData![propertyName] = {
				selector: `.${compId}${selector}`,
				containerType,
			}
		})
	})

	return pathToElementData
}
